module.exports = __webpack_public_path__ + "static/media/outline_Default_Left.b417d3cd.svg";